export const SHOULD_DISPLAY_ICON = true;
export const ONLY_SHOW_REDEEM_REWARD_IN_RESTAURANT_CTA = '';
